import React from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher = () => {
  const { i18n, t } = useTranslation();
  const current = i18n.language;

  const setLang = (lng) => {
    if (lng === current) return;
    i18n.changeLanguage(lng);
    document.documentElement.lang = lng;
    document.title = i18n.t('app.title');
  };

  return (
    <div className="flex items-center gap-2 justify-center mt-2">
      <span className="text-xs text-gray-500">{t('switch.label')}:</span>
      <button
        onClick={() => setLang('zh')}
        className={`px-2 py-1 rounded text-xs border ${current.startsWith('zh') ? 'bg-blue-600 text-white border-blue-600' : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'}`}
        aria-label={t('aria.switch.zh')}
      >
        {t('lang.zh')}
      </button>
      <button
        onClick={() => setLang('en')}
        className={`px-2 py-1 rounded text-xs border ${current.startsWith('en') ? 'bg-blue-600 text-white border-blue-600' : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'}`}
        aria-label={t('aria.switch.en')}
      >
        {t('lang.en')}
      </button>
    </div>
  );
};

export default LanguageSwitcher;